import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgChevronRightIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M38.4 29.568 23 17.248l1.999-2.498 15.4 12.32a3.2 3.2 0 0 1 1.2 2.498v4.862a3.2 3.2 0 0 1-1.2 2.5l-15.4 12.319L23 46.75l15.4-12.32z"
    />
  </svg>
)
export default SvgChevronRightIcon
